import React from 'react';
import { setConfiguration } from 'react-grid-system';
import { ErrorBoundary } from './components/ErrorBoundary';
import 'react-toastify/dist/ReactToastify.css';
import { AppRoutes } from './routes/AppRouter';

setConfiguration({
  breakpoints: [576, 768, 1024, 1200, 1600],
});

export const App = () => (
  <ErrorBoundary>
    <div className="App">
      <AppRoutes />
    </div>
  </ErrorBoundary>
);
